import axios from 'axios';
import { API_BASE_URL } from './scanApi';

// Liste publique paginée des jeux à risque (par type + recherche par nom).
export const getRisks = ({ type, q, page = 1, pageSize = 24 } = {}) =>
  axios.get(`${API_BASE_URL}/risks`, { params: { type, q, page, pageSize } });
